import  { createContext, useEffect, useState } from 'react';
import { auth } from '../useFirebaseInit';

export const AppContext = createContext();

export default function AppContextProvider({ children }) {

  const [isMobile, setIsMobile] = useState(window.innerWidth < 720 || false)
  
  //choose the screen size 
  const handleResize = () => {
    if (window.innerWidth < 720) {
      setIsMobile(true)
    } else {
      setIsMobile(false)
    }
  }

  useEffect(() => {

    window.addEventListener("resize", handleResize)
  }, [])

  return (
    <AppContext.Provider value={{isMobile:isMobile}}>
      {children}
    </AppContext.Provider>
  )
}

//userName={user.userName} userId={user.userId} pfpUrl={user.pfpUrl} email={user.email} isEmailVerified={user.isEmailVerified}